<template>
  <div>
    <el-popover placement="bottom-start" width="560" :close-delay="50" :offset="-500" trigger="manual"
      @show="handleShow" v-model="visible">
      <!-- 内容 -->
      <div ref="downloadPannel">
        <div style="padding: 15px;padding-top: 0;display: flex;justify-content: space-between;align-items: center;">
          <span>下载中心</span>
          <i class="el-icon-close" style="cursor: pointer;" @click="visible = false"></i>
        </div>
        <el-table ref="table" v-loading="tableLoading" stripe :data="tableData" max-height="200" :show-header="false">
          <el-table-column width="60" align="center">
            <i class="el-icon-document" style="font-size: 30px;"></i>
          </el-table-column>
          <el-table-column width="220">
            <template slot-scope="scope">
              <div style="line-height: 15px">
                <div style="width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  {{ scope.row.taskName }}</div>
                <div style="display: flex;justify-content: space-between;color: #aaa;font-size: 12px;">
                  <span>{{ dict.label.ASYNC_TASK_EXECUTING_STATE[scope.row.status] }}</span>
                  <span>{{ scope.row.submitTime }}</span>
                </div>
                <span style="color: #aaa;font-size: 12px;">{{ scope.row.fileSize }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="130px">
            <template slot-scope="scope">
              {{ scope.row.modeName || '未知来源' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120px">
            <template v-slot="scope">
              <el-button type="text" @click="reGen(scope.row)" v-if="scope.row.status == 3"
                :loading="scope.row.reGenLoading">重试</el-button>
              <el-button type="text" @click="download(scope.row)" v-if="scope.row.status == 2"
                :loading="scope.row.downloading">下载</el-button>
              <el-button type="text" @click="toDel(scope.row)" :loading="scope.row.delLoading">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: space-between;align-items:center;padding-top: 10px;">
          <el-input v-model="taskName" placeholder="输入下载任务名称" clearable style="width: 250px"
            @keyup.enter.native="queryData({ taskName })" @clear="queryData({ taskName })">
            <span slot="suffix">
              <i class="el-input__icon el-icon-search" style="cursor: pointer" @click="queryData({ taskName })"></i>
            </span>
          </el-input>
          <div>
            <el-button type="text" icon="el-icon-refresh" @click="queryData">刷新</el-button>
            <el-button type="text" @click="viewDownlaodCenter">查看更多</el-button>
          </div>
        </div>
      </div>
      <div slot="reference">
        <slot name="trigger" :toggle="toggle"></slot>
      </div>
    </el-popover>
    <download-dialog :visible.sync="downloadCenterVisible" />
  </div>
</template>

<script>
import asyncTaskApi from '@/api/asyncTask'
import { download } from '@/api/data'
import { downloadFile } from '@/utils/index'
import downloadDialog from './downloadDialog.vue'
export default {
  name: "DownloadCenter",
  dicts: ['ASYNC_TASK_EXECUTING_STATE'],
  components: { downloadDialog },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      queryParams: {
        total: 0,
        taskName: '',
        submitTime: []
      },
      downloadCenterVisible: false,
      taskName: '',

      visible: false,

      refreshInterval: null,
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        setTimeout(() => {
          document.addEventListener('click', this.handleClick)
        }, 100);
      }
      else {
        document.removeEventListener('click', this.handleClick)
        // clearInterval(this.refreshInterval)
      }
    }
  },
  created() {
    this.$bus.$on("createAsyncTask", () => this.visible = true);
  },
  methods: {
    handleClick(e) {
      if (this.$refs.downloadPannel) {
        let isSelf = this.$refs.downloadPannel.contains(e.target)
        if (!isSelf) {
          this.visible = false
        }
      }
    },
    handleShow() {
      this.taskName = '',
        this.queryData()
    },
    queryData(params) {
      // clearInterval(this.refreshInterval)
      params = {
        ...this.queryParams,
        ...params,
      }
      if (this.queryParams.submitTime && this.queryParams.submitTime.length > 1) {
        params.submitBeginTime = params.submitTime[0]
        params.submitEndTime = params.submitTime[1]
      }
      this.tableLoading = true
      asyncTaskApi.taskPage(params).then(res => {
        this.tableData = res.records || []
        this.queryParams.page = res.page
        this.queryParams.size = res.size
        this.queryParams.total = res.totalCount
        // if (this.visible) {
        //   this.refreshInterval = setInterval(this.queryData, 5 * 60 * 1000)
        // }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 重试
    reGen(row) {
      this.$set(row, 'reGenLoading', true)
      asyncTaskApi.reGen(row.id).then(res => {
        this.queryData()
      })
        .finally(() => {
          this.$set(row, 'reGenLoading', false)
        })
    },
    // 下载
    download(row) {
      this.$set(row, 'downloading', true)
      if (row.fileUrl) {
        window.open(row.fileUrl)
        this.$set(row, 'downloading', false)
      }
      else {
        download(`/api/manage/async/task/download/${row.id}`, {}).then(result => {
          downloadFile(result, row.taskName, 'zip')
        }).finally(() => {
          this.$set(row, 'downloading', false)
        })
      }
    },
    // 删除
    toDel(row) {
      this.$set(row, 'delLoading', true)
      asyncTaskApi.taskDel(row.id).then(res => {
        this.$message.success('删除成功')
        this.queryData()
      })
        .finally(() => {
          this.$set(row, 'delLoading', false)
        })
    },
    // 查看下载中心
    viewDownlaodCenter() {
      this.visible = false
      this.downloadCenterVisible = true
    },
      toggle() {
        this.visible = !this.visible
      },
  },
  beforeDestroy() {
    this.$bus.$off("createAsyncTask");
  }
}
</script>

<style scoped lang="scss">
.el-icon-download {
  font-size: 22px;
  padding: 5px;
  cursor: pointer;

  &:hover {
    color: #188EFF;
  }
}

// 滚动条的宽度
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
}

// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
}

.icon-btn:hover {
  background: #F3F4F6;
  color: #374151;
}
</style>
